export default "__VITE_ASSET__BoDt6kNu__"